import React from 'react';

import { SVGComponentProps } from './svg.types';

const WhiteboardImageSVG = ({
  fill = 'currentColor',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="20"
        height="19"
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.8174 18.3353H2.91028C2.60481 18.3367 2.30207 18.2777 2.01948 18.1617C1.7369 18.0457 1.48003 17.875 1.26366 17.6593C1.04729 17.4437 0.875676 17.1874 0.758698 16.9052C0.641719 16.623 0.58168 16.3205 0.582033 16.015V5.57242C0.582373 4.95921 0.825305 4.37104 1.25779 3.93632C1.69028 3.5016 2.27719 3.25564 2.89039 3.25214H4.74662L6.52462 1.46883C6.88366 1.13582 7.35293 0.94698 7.84255 0.938477H11.8851C12.3755 0.949533 12.8446 1.14068 13.2031 1.47546L14.9851 3.25876H16.8413C17.4524 3.26365 18.037 3.50931 18.4681 3.94245C18.8993 4.37559 19.1423 4.96127 19.1443 5.57242V16.027C19.1408 16.6416 18.8938 17.2297 18.4573 17.6624C18.0209 18.0951 17.4307 18.3371 16.8161 18.3353H16.8174ZM9.86318 5.57242C10.781 5.57242 11.6782 5.84459 12.4414 6.3545C13.2045 6.86441 13.7993 7.58917 14.1505 8.43713C14.5018 9.28508 14.5937 10.2181 14.4146 11.1183C14.2355 12.0185 13.7936 12.8454 13.1446 13.4944C12.4956 14.1434 11.6687 14.5853 10.7685 14.7644C9.86833 14.9435 8.93527 14.8516 8.08731 14.5003C7.23936 14.1491 6.5146 13.5543 6.00469 12.7912C5.49477 12.028 5.22261 11.1308 5.22261 10.213C5.22261 8.98224 5.71153 7.80189 6.5818 6.93162C7.45208 6.06134 8.63243 5.57242 9.86318 5.57242ZM9.86318 12.5346C10.3224 12.5349 10.7714 12.3989 11.1534 12.144C11.5353 11.8891 11.8331 11.5266 12.009 11.1024C12.1849 10.6782 12.2311 10.2113 12.1417 9.76089C12.0522 9.31045 11.8312 8.89666 11.5066 8.57184C11.182 8.24702 10.7683 8.02578 10.3179 7.93609C9.86754 7.8464 9.40067 7.8923 8.97637 8.06798C8.55208 8.24366 8.18941 8.54123 7.93425 8.92304C7.67909 9.30486 7.5429 9.75377 7.5429 10.213C7.5429 10.8285 7.78731 11.4188 8.22241 11.8542C8.65751 12.2895 9.24768 12.5343 9.86318 12.5346Z"
          fill="#878A92"
        />
      </svg>
    </span>
  );
};

export default WhiteboardImageSVG;
